import styled from 'theme';

export const Expander = styled('div')`
  position: relative;
  height: auto;
  transition: max-height 300ms ease-out;
`;
